import { Card, Empty, Tag, Tooltip } from "antd";
import { useNavigate } from "react-router-dom";
import { PhoneOutlined } from "@ant-design/icons";
import { convertToCompanyTimezoneObject } from "../../../lib/functions";
import { resolveDialableNumber } from "../../../lib/phone";

const BUCKET_TAG = {
  overdue: { color: "red", label: "Overdue" },
  today: { color: "orange", label: "Today" },
  upcoming: { color: "blue", label: "Upcoming" },
};

const titleCase = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : "");

const PriorityActivities = ({ tasks = [], isAdmin }) => {
  const navigate = useNavigate();

  return (
    <Card className="crm-card" variant="borderless">
      <div className="crm-card-head">
        <div>
          <div className="crm-card-title">Priority activities</div>
          <div className="crm-card-sub">Overdue first, then what's due next</div>
        </div>
        <button type="button" className="crm-link" onClick={() => navigate("/crm/tasks")}>
          View all
        </button>
      </div>

      {!tasks.length ? (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No pending activities" style={{ padding: "32px 0" }} />
      ) : (
        <ul className="crm-rows">
          {tasks.map((task) => {
            const tag = BUCKET_TAG[task.bucket] || BUCKET_TAG.upcoming;
            const hasPhone = !!String(task.contact_no || "").replace(/[^\d]/g, "");
            const dial = hasPhone ? resolveDialableNumber(task.contact_no, task.lead_country) : "";
            const meta = [titleCase(task.type), isAdmin ? task.assignee : null].filter(Boolean);

            return (
              <li
                key={task.task_id}
                className="crm-row clickable"
                onClick={() => navigate(`/crm/tasks/${task.task_id}`)}
              >
                <span className="crm-row-main">
                  <span className="crm-row-title">{task.customer_name || "Untitled lead"}</span>
                  <span className="crm-row-meta">
                    {meta.join(" · ")}
                    {meta.length > 0 && " · "}
                    {task.due_date ? convertToCompanyTimezoneObject(task.due_date).format("DD MMM, hh:mm A") : "No due date"}
                  </span>
                </span>
                <Tag color={tag.color} style={{ margin: 0, borderRadius: 12 }}>{tag.label}</Tag>
                <Tooltip title={hasPhone ? `Call ${task.customer_name}` : "No phone number available"}>
                  <a
                    className={`crm-call${hasPhone ? "" : " disabled"}`}
                    href={dial ? `tel:${dial}` : undefined}
                    aria-label={hasPhone ? `Call ${task.customer_name}` : "No phone number"}
                    onClick={(e) => {
                      // Don't also open the task row underneath
                      e.stopPropagation();
                      if (!dial) e.preventDefault();
                    }}
                  >
                    <PhoneOutlined />
                  </a>
                </Tooltip>
              </li>
            );
          })}
        </ul>
      )}
    </Card>
  );
};

export default PriorityActivities;
